// export const baseUrl='https://dev-master.salesolutionbd.com/api/v1';
export const customerURL =
  "https://dev-master.salesolutionbd.com/api/v1/customer/products";
export const baseUrl = "https://web.funnelliner.com";
export const dashboardUrl = "https://dashboard.funnelliner.com/login";
export const shopId = 889061;
